import React from "react";
import Lottie from "react-lottie";

export const LottieLoader = ({ animationData, ...rest }) => {
  return (
    <Lottie
      options={{
        animationData,
        loop: true,
        autoplay: true
      }}
      isClickToPauseDisabled
      {...rest}
    />
  );
};
